"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DATE_FORMATS = void 0;
// Date formats
var DATE_FORMATS = exports.DATE_FORMATS = {
  DD_MM_YYYY: 'DD-MM-YYYY',
  DD_MMM_YYYY: 'DD MMM YYYY',
  YYYY_MMM_YYYY_HH_MM_SS: 'YYYY-MM-DD HH:mm:ss',
  YYYY_MM_DD: 'YYYY-MM-DD',
  WEEKDAY_DD_MMM: 'dddd, DD MMM',
  MMDDYYYY: 'MM/DD/YYYY',
  MMM: 'MMM',
  D: 'd',
  DD_MM_YYYY_FACTORY: 'dd-MM-yyyy'
};